import * as React from 'react'
import ItemRow from '../../../../../common/ItemRow'
import SubtitleComponent from '../../../../../common/SubtitleComponent'
import { Article, Variation } from '../../articlesContainer'
import Articles from './../Articles'
import InstantArticlesModalContainer from './InstantArticlesModalContainer'
import AddMoreArticlesButton from './../AddMoreArticlesButton'
import Location from '../../../adLocations/Location'
import getUuid from '../../../../../common/uuidString'
import { AdFormats } from '../../../adFormat/adFormat'

export interface InstantArticle {
	articles: {
		[uid: string]: Article
	}
	link_description?: string
	link_url?: string
	logo?: string
	logo_id?: string
	client_name?: string
}

interface InstantArticlesProps {
	instantArticles: InstantArticle
	updateVariationField: (
		artUid: string,
		variationNum: number,
		field: keyof Variation,
		content: string,
		instant?: boolean,
	) => void
	duplicateVariation: (articleId: string, variationNo: number, instant?: boolean) => void
	removeVariation: (articleId: string, variationNo: number, instant?: boolean) => void
	addVariation: (articleId: string, instant?: boolean) => void
	updateArticle: (art: Article, instant?: boolean) => void
	addArticle: (arr: Article, instant?: boolean) => void
	selectedLocations?: Location[]
	client?: {
		id: number
		org: string
	}
	updateInstantArticlesProperties: (values: {
		link_description?: string
		link_url?: string
		logo?: string
		logo_id?: string
		client_name?: string
	}) => void
	campaignId?: number
	adFormat: AdFormats
}

const InstantArticles: React.FunctionComponent<InstantArticlesProps> = (props) => {
	const [instantArticlesModal, setInstantArticlesModal] = React.useState(false)
	const [activeTab, setActiveTab] = React.useState(0)
	const [activeInstantArticle, setActiveInstantArticle] = React.useState('')

	// Show variations for copied campaign
	const params = window.location.search.slice(1).split('&')
	const copyingCampaignFrom = !!params.find((p) => p.startsWith('from='))
	const [showVariations, setShowVariations] = React.useState(copyingCampaignFrom || false)

	const createArticle = () => {
		const num = Object.keys(props.instantArticles.articles).length + 1
		const article: Article = {
			uid: getUuid(),
			origin: '',
			num,
			instant: true,
			instantArticle: {
				headline: '',
				image: '',
				introduction: '',
				body: '',
			},
			variations: [],
		}
		article.variations.push(
			{
				uid: getUuid(),
				variation_no: 1,
				theme: '',
				image: '',
				advertiser_name: props.client ? props.client.org : '',
				title: '',
				description: '',
				cta: '',
				targetUrl: '',
				impressionPixel: '',
				suggestion: false,
				is_active: true,
			},
			{
				uid: getUuid(),
				variation_no: 2,
				theme: '',
				image: '',
				advertiser_name: props.client ? props.client.org : '',
				title: '',
				description: '',
				cta: '',
				targetUrl: '',
				impressionPixel: '',
				suggestion: true,
				is_active: true,
			},
			{
				uid: getUuid(),
				variation_no: 3,
				theme: '',
				image: '',
				advertiser_name: props.client ? props.client.org : '',
				title: '',
				description: '',
				cta: '',
				targetUrl: '',
				impressionPixel: '',
				suggestion: true,
				is_active: true,
			},
		)
		props.addArticle(article, true)

		setActiveInstantArticle(article.uid)

		setActiveTab(num - 1)
	}

	const showInstantArticleModal = (article?: string) => {
		if (article) {
			setActiveInstantArticle(article)
		}
		setInstantArticlesModal(true)
	}

	const renderArticles = () => {
		if (props.instantArticles.articles && Object.keys(props.instantArticles.articles).length > 0) {
			return (
				<>
					<Articles
						articles={Object.values(props.instantArticles.articles)}
						updateVariationField={props.updateVariationField}
						duplicateVariation={props.duplicateVariation}
						removeVariation={props.removeVariation}
						addVariation={props.addVariation}
						updateArticle={props.updateArticle}
						selectedLocations={props.selectedLocations}
						showInstantArticleModal={showInstantArticleModal}
						activeTab={activeTab}
						instant={true}
						showVariations={showVariations}
						client={props.client}
						campaignId={props.campaignId}
						adFormat={props.adFormat}
					/>
				</>
			)
		}
	}

	return (
		<div id="instantArticles">
			<SubtitleComponent>Create Instant Articles And Native Ads For Your Campaign</SubtitleComponent>

			<ItemRow name="addArticle" description="">
				<AddMoreArticlesButton addArticle={createArticle} />
			</ItemRow>

			{renderArticles()}

			<InstantArticlesModalContainer
				instantArticles={props.instantArticles}
				updateVariationField={props.updateVariationField}
				duplicateVariation={props.duplicateVariation}
				removeVariation={props.removeVariation}
				addVariation={props.addVariation}
				updateArticle={props.updateArticle}
				client={props.client}
				addArticle={props.addArticle}
				updateInstantArticlesProperties={props.updateInstantArticlesProperties}
				setInstantArticlesModal={setInstantArticlesModal}
				instantArticlesModal={instantArticlesModal}
				activeInstantArticle={activeInstantArticle}
				showVariations={() => setShowVariations(true)}
			/>
		</div>
	)
}
export default InstantArticles
